import { computed, ref } from "vue";

export type TState = "idle" | "pending" | "done" | "error";

export function useState(defaultState: TState = "idle") {
  const state = ref<TState>(defaultState);

  const value = computed(() => {
    return state.value;
  });

  const isIdle = computed(() => {
    return state.value === "idle";
  });

  const isPending = computed(() => {
    return state.value === "pending";
  });

  const isDone = computed(() => {
    return state.value === "done";
  });

  const isError = computed(() => {
    return state.value === "error";
  });

  const setState = (next: TState) => {
    state.value = next;
  };

  return {
    state,
    value,
    setState,
    isIdle,
    isPending,
    isDone,
    isError,
  };
}
